<template>
  <div>
    <div>
      <h2>{{ $t("label_administration_wizard_roles") }}</h2>
      <div
        v-if="getAllStoreInfo.roles && getAllStoreInfo.roles.length"
        style="margin-bottom: 20px; margin-top: 20px"
      >
        <div>{{ $t("label_administration_wizard_newRoleAddedAutomatically") }}</div>
        <ul>
        <li v-for="(role,roleIndex) in getAllStoreInfo.roles">
          {{role.name}} <b v-if="roleIndex===0">{{$t('label_administration_wizard_newRoleAddedAutomaticallySingle')}}</b><b v-if="roleIndex===1">{{$t('label_administration_wizard_newRoleAddedAutomaticallyMultiple')}}</b>
        </li>
        </ul>
      </div>
    </div>
    <div style="margin-top: 100px">
      <h2 v-if="getAllStoreInfo.roles.length">{{ $t("label_administration_wizard_users") }}</h2>
      <b-button
        type="button"
        :disabled="!getAllStoreInfo.roles || !getAllStoreInfo.roles.length"
        variant="primary"
        style="margin: 15px auto; display: block"
        @click="addUser()"
      >
        {{ $t("label_administration_wizard_addNewUser") }}
      </b-button>
      <b-tabs>
        <user-to-create
          v-for="(user, indexUser) in getAllStoreInfo.users"
          ref="user"
          :key="indexUser"
          :user="user"
          :index-user="indexUser"
        ></user-to-create>
      </b-tabs>
      <div />
    </div>
  </div>
</template>
<script>
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import { mapGetters } from "vuex";
import RoleToCreate from "@/components/modules/administration/businessCreation/tabs/RoleToCreate";
import UserToCreate from "@/components/modules/administration/businessCreation/tabs/UserToCreate";
import GivenAccess from "@/components/modules/administration/businessCreation/tabs/GivenAccess";

export default {
  name: "RolesAndUsersTab",
  components: {GivenAccess, UserToCreate, RoleToCreate},
  methods: {
    addRole() {
      const payload = {};
      payload["storeName"] = "roles";
      this.$store.dispatch("addToArray", payload);
    },
    addUser() {
      const payload = {};
      payload["storeName"] = "users";
      this.$store.dispatch("addToArray", payload);
    },
    async verifyValidity(){
      let ret =true
      if (this.$refs.role && this.$refs.role.length) {
        for (let index = 0; index < this.$refs.role.length; index++) {
          const valid = await this.$refs.role[index].$refs.role.validForm();
          ret = ret && valid;
          if (this.$refs.role[index].$refs.access && this.$refs.role[index].$refs.access.length) {
            for (let indexA = 0; indexA < this.$refs.role[index].$refs.access.length; indexA++) {
              const valid = this.$refs[index].$refs.access[indexA].validFormControls();
              ret = ret && valid;
            }
          }
        }
      }
      if (this.$refs.user && this.$refs.user.length) {
        for (let index = 0; index < this.$refs.user.length; index++) {
          const valid = await this.$refs.user[index].$refs.user.validForm();
          ret = ret && valid;
        }
      }
      return ret
    }
  },
  computed: {
    ...mapGetters(["getAllStoreInfo"]),
  },
};
</script>

<style lang="scss" scoped>
.new-id {
  font-size: 11px;
  color: gray;
}

.error {
  color: red;
}

.ok {
  color: green;
}

.message-error {
  font-size: 16px;
  color: red;
  text-align: center;
  padding: 30px;
}

.delete-tab {
  color: red;
  font-weight: bold;
  margin-left: 5px;
  padding: 2px 5px;
  font-size: 15px;
  transition: 0.3s;

  &:hover {
    font-size: 13px;
  }
}
</style>
